import { html, LitElement } from "lit";
import { customElement } from "lit/decorators.js";

@customElement("trust-pilot")
export class TrustPilot extends LitElement {
  override createRenderRoot() {
    return this;
  }

  override render() {
    return html`<div
      class="twf-bg-[#F7F7F7] twf-px-4 md:twf-px-6 xl:twf-px-8 twf-py-8 lg:twf-py-16"
    >
      <div
        id="trustwidget"
        class="trustpilot-widget lg:twf-max-w-[1320px] twf-mx-auto"
        data-locale="en-US"
        data-template-id="53aa8912dec7e10d38f59f36"
        data-businessunit-id="57a7d49e0000ff0005933690"
        data-style-height="100%"
        data-style-width="100%"
        data-theme="light"
        data-stars="4,5"
        data-review-languages="en"
        data-font-family="Nunito Sans"
      >
        <a
          href="https://www.trustpilot.com/review/cashrewards.com.au"
          target="_blank"
          rel="noopener"
          >Trustpilot</a
        >
      </div>
    </div>`;
  }
}
